import styled from 'styled-components'
import { DarkGreen, Red, DarkGray } from '../../../../../../assets/colors'

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  outline-color: #002d63;
  width: 126px;
  height: 48px;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  color: #ffffff;
  background-color: ${(props) => props.isDamage ? Red : DarkGreen};
  :disabled {
    background: ${(props) =>
    (props.disabledColor ? props.disabledColor : DarkGray)};
    cursor: not-allowed;
  }
`

export const Text = styled.p`
  font-size: 16px;
  margin: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
